var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTube = function SvgIconTube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m7.315 18.805 11.49-11.49 6.32 6.32-11.49 11.49zm2.298 0 4.022 4.022 9.192-9.192-4.022-4.022z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m13.635 22.827 9.192-9.193L37.19 27.999a6.5 6.5 0 1 1-9.192 9.192zm2.298 0L29.147 36.04a4.875 4.875 0 1 0 6.894-6.894L22.827 15.933z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m19.954 23.402 6.32-6.32 9.767 9.767-6.32 6.32zm2.298 0 7.469 7.468 4.022-4.021-7.47-7.47zM10.762 15.358l6.032 6.033-1.149 1.149-6.032-6.033zM13.634 12.486l6.033 6.032-1.15 1.149-6.032-6.033zM16.507 9.613l6.032 6.033-1.149 1.148-6.032-6.032z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M24.802 30.188c-.52.52-.836.983-.917 1.227l-1.542-.514c.206-.618.752-1.304 1.31-1.862.578-.579 1.294-1.143 1.97-1.48l.727 1.453c-.473.236-1.05.677-1.548 1.176",
    clipRule: "evenodd"
  })));
};
export default SvgIconTube;